module.exports = __webpack_public_path__ + "static/media/industry_icon2.8c13a986.svg";